import React from "react";
import { TrackedObjChange } from "../document/ObjectsListUpdatesPanel";
import { formatMessage } from "../../utils/helpers/LanguageHelper";

export const getStatusColor = (trackedChange: TrackedObjChange) => {
  const typePill = trackedChange.userAction ?? trackedChange.status;

  if (typePill === "ADD") return "var(--color-blue)";
  if (typePill === "CREATE") return "var(--color-blue)";
  if (typePill === "EDIT") return "var(--color-yellow)";
  if (typePill === "UPDATE") return "var(--color-green)";
  if (typePill === "DELETE") return "var(--color-red)";
  if (typePill === "RESTORE") return "var(--color-blue)";
  else return "red";
};
export const getStatusLabel = (trackedChange: TrackedObjChange) => {
  const typeLabel = trackedChange.userAction ?? trackedChange.status;
  if (typeLabel === "ADD") return formatMessage("cof.objectlist.changetracker.status.add");
  if (typeLabel === "CREATE") return formatMessage("cof.objectlist.changetracker.status.add");
  if (typeLabel === "EDIT") return formatMessage("cof.objectlist.changetracker.status.edit");
  if (typeLabel === "UPDATE") return formatMessage("cof.objectlist.changetracker.status.update");
  if (typeLabel === "DELETE") return formatMessage("cof.objectlist.changetracker.status.delete");
  if (typeLabel === "RESTORE") return formatMessage("cof.objectlist.changetracker.status.restore");
  else return "unknown";
};
export const TrackedChangeOperationTypePill = ({ trackedChange }: { trackedChange: TrackedObjChange }) => {
  return (
    <span
      style={{
        backgroundColor: getStatusColor(trackedChange),
        padding: "2px 16px 2px 16px",
        borderRadius: "4px",
        height: "18px",
        lineHeight: "1",
        fontSize: "12px",
        fontWeight: "600",
        color: "white",
      }}
    >
      {getStatusLabel(trackedChange).toUpperCase()}
    </span>
  );
};
